import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';
import OwnRoutes from './Own/OwnRoutes';
import TeamRoutes from './Team/TeamRoutes';
import { getSignleStoredData } from '../../../../helpers/localStorageHelper';
import { useGetBioMetricEmployeeList } from '@hooks';
import { AttendanceNavigation } from './Navigation/AttendanceNavigation';

const AddAttendancePage = loadable(() => import('./AddAttendancePage'), {
  fallback: <Loader />
});
const EditAttendancePage = loadable(() => import('./EditAttendancePage'), {
  fallback: <Loader />
});
const ViewAttendancePage = loadable(() => import('./ViewAttendancePage'), {
  fallback: <Loader />
});
const AttendanceRoute = ({ t, alert }) => {
  const [employeeCanViewTeam, setEmployeeCanViewTeam] = useState([]);
  const [updateSelectedTab, setUpdateSelectedTab] = useState(
    getSignleStoredData('attendanceSelectFilterData') || 'pending'
  );

  // Get Employee List (0 = only active employee , 1 = all employee list)
  const { data: employeeList, isLoading: isEmployeeLoading } = useGetBioMetricEmployeeList();
  useEffect(() => {
    if (!isEmployeeLoading && employeeList?.data?.employee_list) {
      setEmployeeCanViewTeam(employeeList?.data?.employee_list?.length ?? 0);
    }
  }, [employeeList, isEmployeeLoading]);

  if (isEmployeeLoading) {
    return <div>Loading...</div>;
  }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AttendanceNavigation
            t={t}
            employeeCanViewTeam={employeeCanViewTeam}
            updateSelectedTab={updateSelectedTab}
            setUpdateSelectedTab={setUpdateSelectedTab}
            alert={alert}
          />
        }>
        {TeamRoutes({ t, employeeCanViewTeam, updateSelectedTab, alert })}
        {OwnRoutes({ t, updateSelectedTab, alert })}
      </Route>
      <Route exact path="/add" element={<AddAttendancePage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditAttendancePage t={t} alert={alert} />} />
      <Route exact path="/view/:id" element={<ViewAttendancePage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
AttendanceRoute.propTypes = {
  t: PropTypes.func
};
export default AttendanceRoute;
